<template>
  <custom-callout border-color="orange" class="mb-4 shadow" :has-toggle="false">
    <icon-view
      id="icon-invoice"
      icon="fas fa-id-card"
      icon-background="#f87058"
      icon-color="#fff"
      icon-size="14px"
      title="Editar SSN"
    />
    <div class="row mt-3">
      <div class="col-md-6">
        <validation-observer ref="ssnForm" novalidate tag="form">
          <validation-provider
            class="p-0 m-0"
            v-slot="{ errors }"
            :custom-messages="{
              required: 'El número de seguro social es requerido.',
              ssn: 'El número de seguro social no es válido.',
            }"
            rules="required|ssn"
          >
            <custom-input
              v-model="socialSecurityNumber"
              :custom-error-msg="errors[0]"
              :error="errors[0]"
              label="SSN:"
              mask-type="Personalssn"
              maxlength="11"
              placeholder="xxx-xx-xxxx"
              class="col-12 col-md-8 p-0 m-0"
              @input="validateField"
            />
          </validation-provider>
        </validation-observer>
      </div>
      <div class="col-md-12 text-right pt-4">
        <action-button
          id="cancel-btn"
          i="fas fa-times-circle"
          variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
          @click="cancel"
        >
          Cancelar
        </action-button>
        <action-button
          id="success-btn"
          i="fas fa-save"
          variant="success pl-4 pr-4"
          @click="create"
        >
          Guardar
        </action-button>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import CustomInput from 'CustomInput';

export default {
  name: 'EditSSN',
  components: {
    IconView,
    ActionButton,
    CustomCallout,
    CustomInput,
  },
  data: () => ({
    socialSecurityNumber: null,
    shouldValidate: true,
  }),
  methods: {
    validateField() {
      if (this.shouldValidate) {
        this.$refs.ssnForm.validate();
      }
    },
    cancel() {
      this.shouldValidate = false;
      this.$emit('cancel');
      this.shouldValidate = true;
    },
    async create() {
      const isValid = await this.$refs.ssnForm.validate();
      if (isValid) {
        this.$emit('edit', this.socialSecurityNumber);
      }
    },
  },
};
</script>

<style scoped>
>>> .dot {
  width: 31px !important;
  height: 31px !important;
}

>>> .color-gray-7 {
  color: #3f5b60;
}
</style>
